import React, { useMemo, useState, useEffect } from "react";

import {
Layout,
Menu,
Drawer,
Button,
Typography,
Input
} from "antd";

import {
MenuFoldOutlined,
MenuUnfoldOutlined,
DashboardOutlined,
BarChartOutlined,
CalendarOutlined,
TeamOutlined,
ReadOutlined,
DollarOutlined,
SettingOutlined,
UsergroupAddOutlined,
SearchOutlined,
WalletOutlined,
CreditCardOutlined,
TransactionOutlined,
UserAddOutlined,
SafetyCertificateOutlined,
SolutionOutlined,
ApartmentOutlined,
BookOutlined,
FileTextOutlined,
FileSearchOutlined,
PaperClipOutlined,
CheckCircleOutlined,
TrophyOutlined,
LineChartOutlined,
FileDoneOutlined,
PieChartOutlined,
IdcardOutlined,
AccountBookOutlined
} from "@ant-design/icons";
import {
    CheckSquareOutlined
} from "@ant-design/icons";

import {
FaClipboardList,
FaReceipt,
FaGraduationCap,
FaChalkboardTeacher
} from "react-icons/fa";

import { motion } from "framer-motion";

import PrintTestByClass from "../pages/Teachers/PrintTestByClass";

import Overview from "./pages/Overview";
import Analytics from "./pages/Analytics";
// import Search from "./Search";
import UserSearchBox from "../SchoolDashApp/UserDetails/UserSearchBox";
import UserDetailsPage from "../SchoolDashApp/UserDetails/UserDetailsPage";
import ProfileImage from "./ProfileImage";

import AddStudentsStaff from "./NewStudents/AddStudentsStaff";
import AdmissionForm from "./NewStudents/AdmissionForm/AdmissionForm";
import StudentAdmission from "./NewStudents/AdmissionForm/StudentAdmission";

import GradeDistribution from "../pages/Reportcard/GradeDistribution";
import ReportCard from "./ReportCard";
import PromotionDashboard from "./AcademyYearSelection/PromotionDashboard";

import ClassViewList from "../SchoolDashApp/Class/ClassViewList";
import SubjectViewList from "../SchoolDashApp/Class/Subjects/SubjectViewList";


import TeacherDataForm from "../pages/Teachers/TeacherDataForm";
import SupportStaff from "../pages/Teachers/SupportStaff";

import AttendanceRecord from "../pages/Attendance/AttendanceRecord";
import AttendanceData from "../pages/Attendance/AttendanceData";

import FinanceDashboard from "../pages/FinancialReports/FinanceDashboard";
import HighAveragesPage from "../SchoolDashApp/ReportCard/HighAveragesPage";
import StudentStatusSummary from "../SchoolDashApp/StudentStatusSummary";
import PeriodReport from "../pages/Reportcard/PeriodReport";

import BulkTestScorePage from "../SchoolDashApp/ReportCard/BulkTestScorePage";
import TopStudentPerPeriod from "../SchoolDashApp/ReportCard/TopStudentPerPeriod";

import Loan from "../pages/FinancialReports/Loan";
import AssignmentView from "../pages/Teachers/AssignmentView";
import GetStudentNotes from "../pages/Teachers/GetStudentNotes";

import FinancialPaymentRecord from "../SchoolDashApp/FinancialPaymentRecord";
import OtherFee from "../pages/FinancialReports/OtherFee";
import PaymentRecord from "../SchoolDashApp/PaymentRecord";
import SchoolFeesData from "../SchoolDashApp/SchoolFeesData";

import OtherFeesPayment from "../SchoolDashApp/OtherFeesPayment";
import MonthlyFinancialRecord from "../pages/FinancialReports/MonthlyFinancialRecord";
import Expenditure from "../pages/FinancialReports/Expenditure";

import TestPraint from "../pages/Teachers/TestPraint";
import TestAttachmentView from "../SchoolDashApp/TestAttachmentView";

import CertificateDashboard from "./certificate/CertificateDashboard";
import DailyPaymentTransaction from "../SchoolDashApp/DailyTransaction/DailyPaymentTransaction";
import StudentPaymentHistory from "../SchoolDashApp/DailyTransaction/StudentPaymentHistory";

import PostTodoList from "./CalenderAndTodo/PostTodoList";

import Payroll from "../pages/Teachers/Payroll";
import StudentsIDCard from "../pages/Students/IdCards/StudentsIDCard";

import Darkmode from "./Darkmode/Darkmode";
import NotificationIcon from "../components/ChatApp/NotificationIcon";
import Notice from "../components/ChatApp/Notice";
import ComplaintUnit from "../Dashboard/ComplaintUnit";
import NewBlackList from "./NewBlackList";

import logo from "./assets/savationChristLogo.png";



const { Header, Sider, Content } = Layout;
const { Title, Text } = Typography;

// =====================================================
// MENU ITEMS
// IMPORTANT:
// KEEP THIS OUTSIDE THE COMPONENT
// =====================================================

const menuItems = [

{
key: "overview",
icon: <DashboardOutlined />,
label: "Dashboard"
},

{
key: "dailytransaction",
icon: <DashboardOutlined />,
label: "Daily Transaction" 
},

{
key: "studentpaymentistory",
icon: <DashboardOutlined />,
label: "Students Transaction History" 
},

{
key: "classfees",
icon: <FaGraduationCap />,
label: "Class Fees"
},

{
key: "feesrecord",
icon: <DollarOutlined />,
label: "Fees Record"
},

// =========================
// STUDENTS & ADMISSION
// =========================

{
key: "studentsadmission",
icon: <UsergroupAddOutlined />,
label: "Students Admission"
},

{
key: "admissionlist",
icon: <TeamOutlined />,
label: "Students List"
},

{
key: "promotion",
icon: <UserAddOutlined />,
label: "Promotion"
},

{
key: "studentscertificate",
icon: <SafetyCertificateOutlined />,
label: "Students Certificate"
},

{
key: "studentsidcards",
icon: <IdcardOutlined />,
label: "Generate ID Cards"
},

{
key: "complaintunit",
icon: <IdcardOutlined />,
label: "Manage Students Complain"
},

{
key: "statusrecord",
icon: <SolutionOutlined />,
label: "Students Status Record"
},

// =========================
// CLASSES & SUBJECTS
// =========================

{
key: "classviewlist",
icon: <ApartmentOutlined />,
label: "Grade Classes"
},

{
key: "subjectviewlist",
icon: <BookOutlined />,
label: "Subject ViewList"
},

// =========================
// TEACHERS & STAFF
// =========================

{
key: "teacherdata",
icon: <FaChalkboardTeacher />,
label: "Teacher Data"
},

{
key: "supportstaff",
icon: <TeamOutlined />,
label: "Support Staff Data"
},

{
key: "getteachernotes",
icon: <FileTextOutlined />,
label: "Teacher Notes"
},

// =========================
// TESTS, ASSIGNMENTS & NOTES
// =========================

{
key: "testprint",
icon: <FileSearchOutlined />,
label: "Teacher Test"
},

{
key: "printtestbyclass",
icon: <FileDoneOutlined />,
label: "Print Test By Class"
},

{
key: "testattachmentview",
icon: <PaperClipOutlined />,
label: "Test File or Attachment"
},

{
key: "studentsassignments",
icon: <FaClipboardList />,
label: "Students Assignments"
},

{
key: "studentsnotes",
icon: <ReadOutlined />,
label: "Students Notes"
},

// =========================
// ATTENDANCE
// =========================

{
key: "attendancerecord",
icon: <CheckCircleOutlined />,
label: "Attendance Record"
},

{
key: "attendancedata",
icon: <CalendarOutlined />,
label: "Attendance Data"
},

// =========================
// GRADES & REPORTS
// =========================

{
key: "gradedistribution",
icon: <PieChartOutlined />,
label: "Grades Distribution"
},

{
key: "bulkgrades",
icon: <FaChalkboardTeacher />,
label: "Bulk Grades"
},

{
key: "topstudents",
icon: <TrophyOutlined />,
label: "Top Students"
},

{
key: "highaverages",
icon: <LineChartOutlined />,
label: "High Yearly Averages"
},

{
key: "periodicreport",
icon: <FileDoneOutlined />,
label: "Periodic Report"
},

{
key: "reportcard",
icon: <FileTextOutlined />,
label: "Report Card"
},

// =========================
// FEES & FINANCE
// =========================

{
key: "financedashboard",
icon: <BarChartOutlined />,
label: "Semester Fees Summary"
},



{
key: "feesallocation",
icon: <AccountBookOutlined />,
label: "Fees Allocation"
},



{
key: "otherfees",
icon: <FaReceipt />,
label: "Other Fees"
},

{
key: "cleararrears",
icon: <CheckCircleOutlined />,
label: "Clear & Arrears"
},

{
key: "monthlyrecords",
icon: <CalendarOutlined />,
label: "Monthly Records"
},

{
key: "expenditure",
icon: <TransactionOutlined />,
label: "Expenditure"
},

{
key: "loan",
icon: <CreditCardOutlined />,
label: "Loan"
},

// =========================
// PAYROLL & ANALYTICS
// =========================

{
key: "payroll",
icon: <WalletOutlined />,
label: "Payroll Management"
},

{
key: "analytics",
icon: <BarChartOutlined />,
label: "Analytics"
},

// =========================
// SYSTEM USERS & SETTINGS
// =========================

{
key: "systemusers",
icon: <UsergroupAddOutlined />,
label: "Add System Users"
},

{
key: "newblacklist",
icon: <FaChalkboardTeacher />,
label: "Secure"
},

{
key: "settings",
icon: <SettingOutlined />,
label: "Settings"
}

];

// =====================================================
// DASHBOARD
// =====================================================

const NewBusinessManagerDashboard = () => {

const [collapsed, setCollapsed] = useState(false);

const [drawerOpen, setDrawerOpen] = useState(false);

const [darkMode, setDarkMode] = useState(false);

const [activePage, setActivePage] = useState("overview");
const [selectedUser, setSelectedUser] = useState(null);
const [menuSearch, setMenuSearch] = useState("");

const [
    todoOpen,
    setTodoOpen
] = useState(false);

const [isMobile, setIsMobile] = useState(
window.innerWidth < 768
);

// =====================================================
// FILTER MENU
// =====================================================

const filteredMenuItems = useMemo(() => {


const search = menuSearch.trim().toLowerCase();

if (!search) {
  return menuItems;
}

return menuItems.filter(item =>
  item.label.toLowerCase().includes(search)
);


}, [menuSearch]);

// =====================================================
// RESPONSIVE SCREEN SIZE
// =====================================================

useEffect(() => {


const handleResize = () => {

  setIsMobile(window.innerWidth < 768);

};

window.addEventListener(
  "resize",
  handleResize
);

return () => {

  window.removeEventListener(
    "resize",
    handleResize
  );

};


}, []);

// =====================================================
// CUSTOM SCROLLBAR
// =====================================================

useEffect(() => {


const style = document.createElement("style");

style.innerHTML = `

  ::-webkit-scrollbar {
    width: 9px;
    height: 3px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: #800000;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #5a0000;
  }

`;

document.head.appendChild(style);

return () => {

  document.head.removeChild(style);

};


}, []);

// =====================================================
// THEME
// =====================================================

const theme = useMemo(() => ({


darkMode,

background: darkMode
  ? "#0f172a"
  : "#f5f7fb",

sidebar: darkMode
  ? "#111827"
  : "#ffffff",

header: darkMode
  ? "#111827"
  : "#ffffff",

card: darkMode
  ? "#1e293b"
  : "#ffffff",

inputBackground: darkMode
  ? "#1e293b"
  : "#ffffff",

text: darkMode
  ? "#ffffff"
  : "#172033",

secondary: darkMode
  ? "#cbd5e1"
  : "#64748b",

border: darkMode
  ? "#334155"
  : "#e5e7eb",

primary: "#2563eb"


}), [darkMode]);

// =====================================================
// PAGE RENDERING
// =====================================================

const renderPage = () => {

  if (selectedUser) {
    return (
      <UserDetailsPage
        theme={theme}
        selectedUser={selectedUser}
      />
    );
  }


switch (activePage) {

  case "analytics":
    return <Analytics theme={theme} />;


  case "payroll":
    return <Payroll theme={theme} />; 

  case "dailytransaction":
    return <DailyPaymentTransaction theme={theme} />; 

  case "studentpaymentistory":
    return <StudentPaymentHistory theme={theme} />; 

  case "systemusers":
    return <AddStudentsStaff theme={theme} />;


  case "studentsadmission":
    return <AdmissionForm theme={theme} />;


  case "admissionlist":
    return <StudentAdmission theme={theme} />;


  case "gradedistribution":
    return <GradeDistribution theme={theme} />;


  case "promotion":
    return <PromotionDashboard theme={theme} />;


  case "studentscertificate":
    return <CertificateDashboard theme={theme} />;

  
  case "studentsidcards":
    return <StudentsIDCard theme={theme} />;

  case "complaintunit":
    return <ComplaintUnit theme={theme} />;


  case "teacherdata":
    return <TeacherDataForm theme={theme} />;


  case "supportstaff":
    return <SupportStaff theme={theme} />;


  case "testprint":
    return <TestPraint theme={theme} />;


  case "printtestbyclass":
    return <PrintTestByClass theme={theme} />;


  case "getteachernotes":
    return <GetStudentNotes theme={theme} />;


  case "testattachmentview":
    return <TestAttachmentView theme={theme} />;


  case "attendancerecord":
    return <AttendanceRecord theme={theme} />;


  case "attendancedata":
    return <AttendanceData theme={theme} />;


  case "statusrecord":
    return <StudentStatusSummary theme={theme} />;


  case "financedashboard":
    return <FinanceDashboard theme={theme} />;


  case "highaverages":
    return <HighAveragesPage theme={theme} />;


  case "topstudents":
    return <TopStudentPerPeriod theme={theme} />;


  case "classviewlist":
    return <ClassViewList theme={theme} />;


  case "subjectviewlist":
    return <SubjectViewList theme={theme} />;


  case "periodicreport":
    return <PeriodReport theme={theme} />;


  case "reportcard":
    return <ReportCard theme={theme} />;


  case "studentsassignments":
    return <AssignmentView theme={theme} />;


  case "studentsnotes":
    return <GetStudentNotes theme={theme} />;


  case "feesrecord":
    return <FinancialPaymentRecord theme={theme} />;


  case "feesallocation":
    return <OtherFee theme={theme} />;


  case "cleararrears":
    return <PaymentRecord theme={theme} />;


  case "classfees":
    return <SchoolFeesData theme={theme} />;


  case "otherfees":
    return <OtherFeesPayment theme={theme} />;


  case "monthlyrecords":
    return <MonthlyFinancialRecord theme={theme} />;


  case "expenditure":
    return <Expenditure theme={theme} />;

   case "newblacklist":
    return <NewBlackList theme={theme} />;

  case "loan":
    return <Loan theme={theme} />;


  case "bulkgrades":
    return <BulkTestScorePage theme={theme} />;

 

case "newblacklist":
return (
    <UserDetailsPage
    selectedUser={selectedUser}
    />
    );

  default:
    return <Overview theme={theme} />;




}


};

// =====================================================
// SIDEBAR
// =====================================================

const sidebar = (


<div
  style={{
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    background: "transparent"
  }}
>

  {/* LOGO */}

  <div
    style={{
      height: 75,
      flexShrink: 0,
      display: "flex",
      alignItems: "center",
      gap: 12,
      padding: "0 18px",
      borderBottom: `1px solid ${theme.border}`
    }}
  >

    <img
      src={logo}
      alt="logo"
      style={{
        width: 42,
        height: 42,
        borderRadius: 12,
        objectFit: "cover"
      }}
    />


    {!collapsed && (

      <div>

        <Title
          level={5}
          style={{
            margin: 0,
            color: theme.text
          }}
        >
          Salvation In Christ School System
      
        </Title>


        <Text
          style={{
            fontSize: 12,
            color: theme.secondary
          }}
        >
          SMS - Portal
        </Text>

      </div>

    )}

  </div>


  {/* PROFILE */}

  {!collapsed && (

    <div
      style={{
        flexShrink: 0
      }}
    >

      <ProfileImage theme={theme} />

    </div>

  )}


  {/* MENU AREA */}

  {/* STATIC SEARCH BAR */}

{!collapsed && (
  <div
    style={{
      flexShrink: 0,
      padding: "12px 12px 6px",
      background: theme.sidebar
    }}
  >
    <Input
      allowClear
      value={menuSearch}
      onChange={(e) => setMenuSearch(e.target.value)}
      placeholder="Search menu..."
      prefix={<SearchOutlined />}
    />
  </div>
)}


{/* ONLY MENU SCROLLS */}

<div
  style={{
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    overflowX: "hidden"
  }}
>
  {/* <Menu
    mode="inline"
    items={filteredMenuItems}
    selectedKeys={[activePage]}
    inlineCollapsed={collapsed}
    onClick={({ key }) => {
      setActivePage(key);
      setMenuSearch("");

      if (isMobile) {
        setDrawerOpen(false);
      }
    }}
    theme={darkMode ? "dark" : "light"}
    style={{
      background: "transparent",
      border: "none"
    }}
  /> */}
  <Menu
  mode="inline"
  items={filteredMenuItems}
  selectedKeys={[activePage]}
  inlineCollapsed={collapsed}
  onClick={({ key }) => {

    // switch page
    setActivePage(key);

    // remove user profile view
    setSelectedUser(null);

    // clear menu search
    setMenuSearch("");

    if (isMobile) {
      setDrawerOpen(false);
    }

  }}
/>
</div>


  {/* FOOTER */}

  <div
    style={{
      height: 55,
      flexShrink: 0,
      display: "flex",
      alignItems: "center",
      padding: "0 15px",
      borderTop: `1px solid ${theme.border}`,
      background: theme.sidebar
    }}
  >

    <Text
      style={{
        fontSize: 12,
        color: theme.secondary
      }}
    >
      © 2026 Salvation In Christ School System
     
    </Text>

  </div>

</div>


);

// =====================================================
// MAIN DASHBOARD
// =====================================================

return (


<div
  style={{
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 999,
    background: theme.background,
    overflow: "auto"
  }}
>

  <Layout
    style={{
      minHeight: "100vh",
      background: theme.background
    }}
  >


    {/* DESKTOP SIDEBAR */}

    {!isMobile && (

      <Sider
        width={260}
        collapsedWidth={75}
        collapsed={collapsed}

        style={{
          position: "fixed",
          height: "100vh",
          background: theme.sidebar,
          borderRight: `1px solid ${theme.border}`,
          overflow: "hidden"
        }}
      >

        {sidebar}

      </Sider>

    )}


    {/* MOBILE DRAWER */}

    {isMobile && (

      <Drawer
        open={drawerOpen}
        width={260}
        bodyStyle={{
          padding: 0
        }}
        onClose={() => setDrawerOpen(false)}
      >

        {sidebar}

      </Drawer>

    )}


    <Layout
      style={{
        marginLeft: isMobile
          ? 0
          : collapsed
            ? 75
            : 260
      }}
    >


      {/* HEADER */}

      <Header
        style={{
          height: isMobile
            ? 60
            : 70,

          padding: isMobile
            ? "0 8px"
            : "0 20px",

          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",

          background: theme.header,

          borderBottom:
            `1px solid ${theme.border}`,

          position: "sticky",
          top: 0,
          zIndex: 10,

          overflow: "hidden"
        }}
      >


        {/* LEFT HEADER */}

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: isMobile
              ? 5
              : 15,

            minWidth: 0
          }}
        >

          <Button
            shape="circle"

            icon={

              isMobile

                ? <MenuUnfoldOutlined />

                : collapsed

                  ? <MenuUnfoldOutlined />

                  : <MenuFoldOutlined />

            }

            onClick={() => {

              if (isMobile) {

                setDrawerOpen(true);

              } else {

                setCollapsed(!collapsed);

              }

            }}

          />


          <div>

            <UserSearchBox
    theme={theme}
    setSelectedUser={setSelectedUser}
    setActiveComponent={setActivePage}
/>
          </div>

        </div>

        {/* to do list */}
       <div>
        <CheckSquareOutlined
        style={{
          fontSize: 25,
          cursor: "pointer",
          color: "#f97316",
          margin: 0,
          padding: 0,
          display: "block"
        }}
        onClick={() => setTodoOpen(true)}
      />

      <PostTodoList
      open={todoOpen}
      setOpen={setTodoOpen}/>
        </div> 


        {/* RIGHT HEADER */}

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: isMobile
              ? 8
              : 20,

            flexShrink: 0
          }}
        >


          <Darkmode
            darkMode={darkMode}
            setDarkMode={setDarkMode}
          />



<div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
  }}
>
  <NotificationIcon theme={theme} />
  <Notice />
</div>


          <div
            style={{
              width: isMobile
                ? 34
                : 45,

              height: isMobile
                ? 34
                : 45,

              overflow: "hidden",

              borderRadius: "50%",

              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >

            <ProfileImage
              theme={theme}
              header
            />

          </div>

        </div>

      </Header>


      {/* CONTENT */}

      <Content
        style={{
          padding: 20,

          background: theme.background,

          minHeight: "calc(100vh - 70px)",

          overflowY: "auto"
        }}
      >

        <motion.div
          initial={{
            opacity: 0,
            y: 15
          }}

          animate={{
            opacity: 1,
            y: 0
          }}

          transition={{
            duration: 0.3
          }}
        >

          {renderPage()}

        </motion.div>

      </Content>

    </Layout>

  </Layout>

</div>


);

};

export default NewBusinessManagerDashboard;
